/**
* Endpoint methods related to the Webshop
*/
import API from "./Api";


export default {

  async readall() {
    return API.get("/subscription/read", "COOKIE_TOKEN_JSON");
  },


}